import { withSvgIcon } from './withSvgIcon';

export const NavBarProjects = withSvgIcon(
  <>
    <path
      d="M4 7.5C4 6.55719 4 6.08579 4.29289 5.79289C4.58579 5.5 5.05719 5.5 6 5.5H8.67157C9.08032 5.5 9.2847 5.5 9.46847 5.57612C9.65224 5.65224 9.79676 5.79676 10.0858 6.08579L11.4142 7.41421C11.7032 7.70324 11.8478 7.84776 12.0315 7.92388C12.2153 8 12.4197 8 12.8284 8H18C18.9428 8 19.4142 8 19.7071 8.29289C20 8.58579 20 9.05719 20 10V18C20 18.9428 20 19.4142 19.7071 19.7071C19.4142 20 18.9428 20 18 20H6C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18V7.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M4 11L20 11" stroke="currentColor" strokeWidth="1.5" />
  </>,
  { viewBox: '0 0 24 24' },
);
